import styled from "styled-components";
import { Container } from "styles/common/container";
import { breakpoints } from "styles";

export const TanyaHowToContainer = styled(Container)`
  padding: 40px 16px;
  @media ${breakpoints.tablet} {
    display: grid;
    grid-template-areas:
      "title title"
      "subtitle subtitle"
      "image pagination";
    grid-gap: 0;
    justify-content: center;
  }
`;

export const TanyaHowToImageWrapper = styled.figure`
  margin: 32px auto;
  position: relative;
  width: 190px;
  height: 350px;

  @media ${breakpoints.tablet} {
    width: 310px;
    height: 570px;
    grid-area: image;
    margin: 40px 16px 40px 0;
  }
  @media ${breakpoints.laptop} {
    margin: 60px;
  }
`;

export const TanyaHowToContentMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media ${breakpoints.tablet} {
    display: none;
  }
`;

export const TanyaHowToTitle = styled.h2`
  margin: 8px 0;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  @media ${breakpoints.tablet} {
    grid-area: title;
    font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  }
`;

export const TanyaHowToSubTitle = styled.h4`
  margin: 0;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.neutral[600]};
  font-weight: normal;
  @media ${breakpoints.tablet} {
    grid-area: subtitle;
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }
`;

export const TanyaHowToHeading = styled.h3`
  margin: 8px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.brand[500]};

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
    margin: 0 0 16px 0;
  }
`;

export const TanyaHowToDesc = styled.p`
  margin: 0;
  font-weight: normal;
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  color: ${({ theme }) => theme.colors.neutral[600]};

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }
`;

export const TanyaHowToPaginationContainer = styled.ul`
  margin: 32px 0;
  list-style: none;
  padding: 0;
  display: flex;
  align-items: center;

  @media ${breakpoints.tablet} {
    margin: 0;
    flex-direction: column;
    grid-area: pagination;
    justify-content: space-around;
  }
`;

export const TanyaHowToPaginationItem = styled.li`
  flex-basis: 40px;
  margin: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${breakpoints.tablet} {
    position: relative;
    align-items: flex-start;
  }

  &:nth-child(2) {
    flex-basis: calc(100% - 100px);

    @media ${breakpoints.tablet} {
      flex-basis: initial;
    }
  }
  &:nth-child(2):after,
  &:nth-child(2):before {
    content: "";
    width: 40%;
    height: 3px;
    background: ${({ theme }) => theme.colors.neutral[200]};

    @media ${breakpoints.tablet} {
      position: absolute;
      width: 5px;
      height: 100%;
      top: 0;
      left: 24px;
    }
  }
  &:nth-child(2):after {
    margin-left: 8px;
    @media ${breakpoints.tablet} {
      margin: 0;
      transform: translateY(60%);
    }
  }
  &:nth-child(2):before {
    margin-right: 8px;
    @media ${breakpoints.tablet} {
      margin: 0;
      transform: translateY(-120%);
    }
  }
`;

export const TanyaHowToPaginationButton = styled.button<{ active?: boolean }>`
  --webkit-appearance: none;
  width: 32px;
  height: 32px;
  font-weight: bold;
  color: ${({ theme, active }) =>
    active ? theme.colors.white : theme.colors.neutral[300]};
  background: ${({ theme, active }) =>
    active ? theme.colors.brand[500] : "none"};
  border-radius: 50%;
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  padding: 4px;
  border: 2px solid currentColor;
  cursor: pointer;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    min-width: 50px;
    width: 50px;
    height: 50px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TanyaHowToContent = styled.div`
  display: none;

  @media ${breakpoints.tablet} {
    max-width: 480px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
`;
